import { HudLandingPage } from './hud/HudLandingPage';
import { HudMobileLandingPage } from './hud/HudMobileLandingPage';
import { useIsMobile } from './hooks/useIsMobile';

const App = () => {
  const isMobile = useIsMobile();
  return isMobile ? <HudMobileLandingPage /> : <HudLandingPage />;
};

export default App;
